var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.196,
    height: 44.196,
    viewBox: "0 0 44.196 44.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discount-shape",
    transform: "translate(-364 -316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.655,23.268l-2.8-2.8a2.957,2.957,0,0,1,0-4.162l2.8-2.8a3.4,3.4,0,0,0,.866-2.081V7.467A2.955,2.955,0,0,1,7.467,4.521h3.959a3.4,3.4,0,0,0,2.081-.865l2.8-2.8a2.957,2.957,0,0,1,4.162,0l2.8,2.8a3.4,3.4,0,0,0,2.081.865h3.959a2.955,2.955,0,0,1,2.946,2.946v3.959a3.4,3.4,0,0,0,.866,2.081l2.8,2.8a2.957,2.957,0,0,1,0,4.162l-2.8,2.8a3.4,3.4,0,0,0-.866,2.081v3.959a2.955,2.955,0,0,1-2.946,2.947H25.348a3.4,3.4,0,0,0-2.081.865l-2.8,2.8a2.957,2.957,0,0,1-4.162,0l-2.8-2.8a3.4,3.4,0,0,0-2.081-.865H7.467a2.955,2.955,0,0,1-2.946-2.947V25.348A3.312,3.312,0,0,0,3.655,23.268Z",
    transform: "translate(367.69 319.73)",
    fill: "none",
    stroke: "#0f4725",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,11.049,11.049,0",
    transform: "translate(380.574 332.574)",
    fill: "none",
    stroke: "#0f4725",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H44.2V44.2H0Z",
    transform: "translate(364 316)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M.495.5H.511",
    transform: "translate(390.197 342.202)",
    fill: "none",
    stroke: "#0f4725",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M.495.5H.511",
    transform: "translate(380.99 332.994)",
    fill: "none",
    stroke: "#0f4725",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard3);
export default __webpack_public_path__ + "static/media/dashboard3.bae5e9327e43bf31c16ada4a154de107.svg";
export { ForwardRef as ReactComponent };